import React, { useState } from "react";
import "./SelectDesignModal.scss";
import SelectTemplateList from "./SelectDesigntemplateListModal";
import CloseIcon from "../../../../components/icons/CloseIcon";
import toast from "react-hot-toast";
import { TemplatesApi } from "../../../../utils/api/Templates";

interface SelectDesignModalProps {
  show: boolean;
  onClose: () => void;
  onSuccess?: () => void;
  stageLabel: string;
  selectedDesignTemplateId: string;
  selectedDesignTemplateStageSlug: string;
  postType: string;
  dynamicStageLabel?: string;
}

const SelectDesignModal: React.FC<SelectDesignModalProps> = ({
  show,
  onClose,
  onSuccess,
  stageLabel,
  selectedDesignTemplateId,
  selectedDesignTemplateStageSlug,
  postType,
  dynamicStageLabel,
}) => {
  const [pendingSelection, setPendingSelection] = useState<any>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  if (!show) return null;

  const handleConfirm = async () => {
    if (!pendingSelection) {
      toast.error("Please select a design first");
      return;
    }

    setIsSubmitting(true);
    try {
      const payload = {
        post_type: postType,
        design_record_id: selectedDesignTemplateId,
        is_stage_update: true,
        stage_id: selectedDesignTemplateStageSlug,
        stage_design_record_id: pendingSelection._id,
      };

      const res = await TemplatesApi.setTemplate(payload);

      if (res?.data?.success) {
        toast.success("Stage design updated!");
        if (onSuccess) {
          onSuccess();
        } else {
          onClose();
        }
      } else {
        toast.error(res?.data?.message || "Failed to update design");
      }
    } catch (error) {
      toast.error("Error occurred");
    } finally {
      setIsSubmitting(false);
    }
  };

  // const handleConfirm = async () => {
  //   if (!pendingSelection) {
  //     toast.error("Please select a design first");
  //     return;
  //   }

  //   setIsSubmitting(true);

  //   try {
  //     const payload = {
  //       post_type: postType,
  //       design_record_id: selectedDesignTemplateId,
  //       is_stage_update: true,
  //       stage_id: selectedDesignTemplateStageSlug,
  //       stage_design_record_id: pendingSelection._id,
  //     };

  //     const res = await TemplatesApi.setTemplate(payload);

  //     if (res?.data?.success) {
  //       toast.success("Stage design updated!");
  //       onClose();
  //     } else {
  //       toast.error(res?.data?.message || "Failed to update design");
  //     }
  //   } catch (error) {
  //     toast.error("Error occurred");
  //   } finally {
  //     setIsSubmitting(false);
  //   }
  // };

  return (
    <div className="modal-overlay">
      <div className="select-design-modal">
        <div className="modal-header">
          <div className="header-text">
            <p className="selected-stage-name">
              Select New Design: {stageLabel}
            </p>
            <p className="stage-sub-lable">
              Choose a new design from the list below to apply to this marketing
              stage
            </p>
          </div>
        </div>

        <div className="modal-body">
          <SelectTemplateList
            selectedDesignTemplateId={selectedDesignTemplateId}
            selectedDesignTemplateStageSlug={selectedDesignTemplateStageSlug}
            postType={postType}
            onSelectTemplate={setPendingSelection}
            dynamicStageLabel={dynamicStageLabel}
          />
        </div>

        <div className="modal-footer">
          <button
            className="btn-cancel"
            onClick={onClose}
            disabled={isSubmitting}
          >
            Cancel
          </button>
          <button
            className="btn-confirm"
            onClick={handleConfirm}
            disabled={isSubmitting}
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
};

export default SelectDesignModal;
